export const connectedTeethPairs = [
  ["18", "17"],
  ["17", "16"],
  ["16", "15"],
  ["15", "14"],
  ["14", "13"],
  ["13", "12"],
  ["12", "11"],
  ["11", "21"],
  ["21", "22"],
  ["22", "23"],
  ["23", "24"],
  ["24", "25"],
  ["25", "26"],
  ["26", "27"],
  ["27", "28"],
  ["38", "37"],
  ["37", "36"],
  ["36", "35"],
  ["35", "34"],
  ["34", "33"],
  ["33", "32"],
  ["32", "31"],
  ["31", "41"],
  ["41", "42"],
  ["42", "43"],
  ["43", "44"],
  ["44", "45"],
  ["45", "46"],
  ["46", "47"],
  ["47", "48"],
];

